import Vue from 'vue'
import Router from 'vue-router'
import config from '@/services/config.js'
// Containers



const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const chat=()=>import('@/views/mypages/chat')
const deals=()=>import('@/views/mypages/deals')
const importCatalog=()=>import('@/views/mypages/importCatalog')
const abandonedCart=()=>import('@/views/mypages/abandonedCart')
const position =()=>import('@/views/mypages/position')
const vouchers =()=>import('@/views/mypages/vouchers')
const voucheradd =()=>import('@/views/mypages/voucheradd')
const changeCard =()=>import('@/views/mypages/changeCard')

const employee=()=>import('@/views/mypages/employee')
const Dashboard1 = () => import('@/views/Dashboard1')
const customer=()=>import('@/views/mypages/customer')
const dealslist=()=>import('@/views/mypages/dealslist')
const mysubscription=()=>import('@/views/mypages/mysubscription')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Switches = () => import('@/views/base/Switches')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tables = () => import('@/views/tables/Tables')
const AdvancedTables = () => import('@/views/tables/AdvancedTables')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Editors
const TextEditors = () => import('@/views/editors/TextEditors')
const CodeEditors = () => import('@/views/editors/CodeEditors')

// Views - Forms
const BasicForms = () => import('@/views/forms/Forms')
const AdvancedForms = () => import('@/views/forms/AdvancedForms')
const ValidationForms = () => import('@/views/forms/ValidationForms')

// Views GoogleMaps
const GoogleMaps = () => import('@/views/GoogleMaps')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')
const Toaster = () => import('@/views/notifications/Toaster')


// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const Landing = () => import('@/views/pages/Landing')
const Plans = () => import('@/views/pages/Plans')
const subscription = () => import('@/views/pages/subscription')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// Plugins
const Draggable = () => import('@/views/plugins/Draggable')
const Calendar = () => import('@/views/plugins/Calendar')
const Spinners = () => import('@/views/plugins/Spinners')

// Views - UI Kits
const Invoice = () => import('@/views/apps/invoicing/Invoice')
const Compose = () => import('@/views/apps/email/Compose')
const Inbox = () => import('@/views/apps/email/Inbox')
const Message = () => import('@/views/apps/email/Message')

//MY PAGES
const categorylist = () => import('@/views/mypages/categorylist')
const productlist = () => import('@/views/mypages/productlist')
const editproduct = () => import('@/views/mypages/editproduct')
const editdoctor = () => import('@/views/mypages/editdoctor')
const editservice = () => import('@/views/mypages/editservice')
const ProductOrder = () => import('@/views/mypages/ProductOrder')
const categoryorder = () => import('@/views/mypages/categoryorder')
const cataloglist = () => import('@/views/mypages/cataloglist')
const newcatalog =()=>import('@/views/mypages/newcatalog')
const vieworder = () => import('@/views/mypages/vieworder')
const Profile = () => import('@/profile/profile')
const Business = () => import('@/profile/Business')
const editbusiness = () => import('@/profile/editbusiness')
const employeelist = () => import('@/views/mypages/employeelist')
const orderList = () => import('@/views/mypages/orderList')
const logout = () => import('@/views/mypages/logout')
const paymentOption = () => import('@/views/mypages/paymentoption')
const deliveryOption = () => import('@/views/mypages/deliveryoption.vue')
const appointments = () => import('@/views/mypages/calendar.vue')
const docotors=()=>import('@/views/mypages/doctors.vue')
const adddoctors=()=>import('@/views/mypages/adddoctor.vue')
const addservice=()=>import('@/views/mypages/addservice.vue')
const services=()=>import('@/views/mypages/services.vue')
const call = () => import('@/views/api/call')


Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          
        },
        {
          path: 'dashboard1',
          name: 'Dashboard1',
          component: Dashboard1
        },
        {
          path: 'appointments',
          name: 'appointments',
          component: appointments
        },
        {
          path: 'categorylist',
          name: 'Category',
          component: categorylist
        },
        {
          path: 'customer',
          name: 'Customer',
          component: customer
        },
        {
          path: 'position',
          name: 'Position',
          component: position
        },
        {
          path: 'dealslist',
          name: 'dealslist',
          component: dealslist
        },

        {
          path: 'vouchers',
          name: 'vouchers',
          component: vouchers
        },
        {
          path: 'mysubscription',
          name: 'Subscription',
          component: mysubscription
        },

        {
          path: 'voucheradd/:id',
          name: 'voucheradd',
          component: voucheradd
        },
{
  path:'changeCard',
  name:'changeCard',
  component:changeCard
},
        {
          path: 'chat',
          name: 'Chat',
          component:chat
        },
        {
          path:'deals',
          name:'deals',
          component:deals
        },
        {
          path:'importCatalog',
          name:'importCatalog',
          component:importCatalog
        },
        {
          path: 'abandonedCart',
          name: 'Abandoned Cart',
          component:abandonedCart
        },

        {
          path: 'employee',
          name: 'Employee List',
          component: employee
        },

        {
          path: 'cataloglist',
          name: 'Catalog',
          component: cataloglist
        },
        {
          path: 'newcatalog',
          name: 'CatalogList',
          component: newcatalog
        },

        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'editbusiness',
          name: 'Edit Business',
          component: editbusiness
        },

        {
          path: 'business',
          name: 'My Store',
          component: Business
        },

        {
          path: 'productlist',
          name: 'Product',
          component: productlist
        },
        {
          path: 'orderList',
          name: 'Orders',
          component: orderList
        },
        {
          path: 'doctors',
          name: 'Doctors',
          component: docotors
        },
        {
          path: 'adddoctors',
          name: 'Add Doctors',
          component: adddoctors
        },
        {
          path: 'addservice',
          name: 'Add Service',
          component: addservice
        },
        {
          path: 'services',
          name: 'Services',
          component: services
        },
        {
          path: 'paymentOption',
          name: 'PaymentOption',
          component: paymentOption
        },
        {
          path: 'deliveryOption',
          name: 'DeliveryOption',
          component: deliveryOption
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'tables',
          redirect: '/tables/tables',
          name: 'Tables',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'tables',
              name: 'Basic tables',
              component: Tables
            },
            {
              path: 'advanced-tables',
              name: 'Advanced tables',
              component: AdvancedTables
            }
          ]
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: { label: 'Users' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'editors',
          redirect: '/editors/text-editors',
          name: 'Editors',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'text-editors',
              name: 'Text Editors',
              component: TextEditors
            },
            {
              path: 'code-editors',
              name: 'Code Editors',
              component: CodeEditors
            }
          ]
        },
        {
          path: 'forms',
          redirect: '/forms/basic-forms',
          name: 'Forms',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'basic-forms',
              name: 'Basic Forms',
              component: BasicForms
            },
            {
              path: 'advanced-forms',
              name: 'Advanced Forms',
              component: AdvancedForms
            },
            {
              path: 'validation-forms',
              name: 'Form Validation',
              component: ValidationForms
            }
          ]
        },
        {
          path: 'google-maps',
          name: 'Google Maps',
          component: GoogleMaps
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            }
          ]
        },
        {
          path: '/editproduct',
          name: 'editproduct',
          component: editproduct
        },
        {
          path: '/editdoctor/:docid',
          name: 'editdoctor',
          component: editdoctor
        },
        {
          path: '/editservice/:docid',
          name: 'editservice',
          component: editservice
        },
        {
          path: '/productOrder',
          name: 'ProductOrder',
          component: ProductOrder
        },
        {
          path: '/categoryorder',
          name: 'category',
          component: categoryorder
        },
        {
          path: '/vieworder/:docid',
          name: 'vieworder',
          component: vieworder
        },
        {
          path: '/employeelist',
          name: 'employeelist',
          component: employeelist
        },
        
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            },
            {
              path: 'toaster',
              name: 'Toaster',
              component: Toaster
            }
          ]
        },
        {
          path: 'plugins',
          redirect: '/plugins/draggable',
          name: 'Plugins',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'draggable',
              name: 'Draggable Cards',
              component: Draggable
            },
            {
              path: 'calendar',
              name: 'Calendar',
              component: Calendar
            },
            {
              path: 'spinners',
              name: 'Spinners',
              component: Spinners
            }
          ]
        },

        {
          path: 'apps',
          name: 'Apps',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'invoicing',
              redirect: '/apps/invoicing/invoice',
              name: 'Invoicing',
              component: {
                render(c) { return c('router-view') }
              },
              children: [
                {
                  path: 'invoice',
                  name: 'Invoice',
                  component: Invoice
                }
              ]
            },
            {
              path: 'email',
              redirect: '/apps/email/inbox',
              name: 'Email',
              component: {
                render(c) { return c('router-view') }
              },
              children: [
                {
                  path: 'compose',
                  name: 'Compose',
                  component: Compose
                },
                {
                  path: 'inbox',
                  name: 'Inbox',
                  component: Inbox
                },
                {
                  path: 'message',
                  name: 'Message',
                  component: Message
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/plans',
      name: 'Plans',
      component: Plans
    },
    {
      path: '/subscribe',
      name: 'subscription',
      component: subscription
    },

    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/landing',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/logout',
      name: 'Logout',
      component: logout
    },
    {
      path: '/call',
      name: 'Call',
      component: call
    },
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/landing','/register'];
  const authRequired = !publicPages.includes(to.path);
  // const loggedIn = await firebase.auth().currentUser;
  const loggedIn = JSON.parse(localStorage.getItem(config.USER_DATA));
  if (authRequired && !loggedIn) {
    return next('landing')
  }
  if (!authRequired && loggedIn) {
    return next('dashboard')
  }
  if (to.meta.canseesponser) {
    if (loggedIn.accountType.toLowerCase() === 'Seller'.toLowerCase()) {
      return next()
    }
    else {
      return next('dashboard')
    }
  }
  if (to.meta.canseecampaigner) {
    if (loggedIn.accountType.toLowerCase() === 'Buyer'.toLowerCase()) {
      return next()
    }
    else {
      return next('dashboard')
    }
  }
  next()
});

export default router;
